import React from 'react';
import { Card, Stack } from 'library/ui';

export default function HowItWorksCard({ children }: { children: React.ReactNode }) {
    return (
        <Card fullHeight tone="muted">
            <Stack gap="sm" fullHeight>
                {children}
            </Stack>
        </Card>
    );
}
